import * as React from "react";
import { PirateWeather } from "source/app/presentation/MainPanel/Weather/PirateWeather/PirateWeather";

export class Weather extends React.Component<{}, {}> {
    constructor(props: {}) {
        super(props);
    }

    render() {
        return (
            <div>
                <PirateWeather />
            </div>
        );
    }
}
